export default __webpack_public_path__ + "cd7c692cac0e7861b50ebed493d0dc33.png";